@let channelSegments = salesChannelSegments$ | async;

<app-dashboard-card>
  <ng-container card-title-icon>
    <mat-icon>pie_chart</mat-icon>
  </ng-container>
  <ng-container card-title-content>
    <div class="header-container">
      <h2>Vendas por canal</h2>
      <span class="header-info">Todos os eventos</span>
    </div>
  </ng-container>
  <ng-container card-content>
    @if (channelSegments) {
      <app-pie-chart canvasId="organizerSalesChannelsChart" [segments]="channelSegments" />
    } @else {
      <p-skeleton height="18rem" />
    }
  </ng-container>
</app-dashboard-card>
